/**
 * Sidebar Navigation
 *
 * Highlights relevant
 */

declare const jQuery: JQueryStatic;

const SidebarNavListItems: HTMLElement[] = [];
const $ = jQuery;

export function initSidebarNavigation() {
  const targets: {
    offset: number;
    $anchor: HTMLAnchorElement;
    $li: HTMLLIElement;
  }[] = [];
  const $list = $('.page__sidebar ul, .b-newtoc');
  const $li = $('.page__sidebar ul > li, .b-newtoc__parent');

  console.log($li);

  $li.each((idx, $el) => {
    SidebarNavListItems.push($el);

    if (idx) {
      $($el).addClass('s--hidden');
    }
  });

  $list.find('a').each((_idx, $anchor) => {
    const hash = new URL($anchor.href, window.location.href).hash;
    const $section = $(hash);
    const offsetTop = $section.offset();

    if (offsetTop != undefined) {
      targets.push({
        offset: offsetTop.top,
        $anchor,
        $li: $($anchor).parents('li').last()[0],
      });
    }
  });

  const updateActiveSidebarElement = () => {
    for (let i = 0; i < targets.length; i++) {
      if (
        targets[i].offset > window.scrollY &&
        targets[i].offset < window.scrollY + window.innerHeight * 0.4
      ) {
        if (!targets[i].$anchor.classList.contains('s--active')) {
          // Remove active class from any sibling menus
          for (
            let liItemPointer = 0;
            liItemPointer < SidebarNavListItems.length;
            liItemPointer++
          ) {
            const element = SidebarNavListItems[liItemPointer];
            element.classList.remove('s--visible');
          }

          // Remove active class from any siblings
          for (let siblings = 0; siblings < targets.length; siblings++) {
            targets[siblings].$li.classList.add('s--active');
            targets[siblings].$li.classList.add('s--hidden');
            targets[siblings].$anchor.classList.remove('s--active');
          }
          targets[i].$anchor.classList.add('s--active');
          targets[i].$li.classList.remove('s--hidden');
          targets[i].$li.classList.add('s--visible');
        }
      }
    }
  };

  if ($list.length) {
    window.requestAnimationFrame(updateActiveSidebarElement);
    const eventHandler = debounce(updateActiveSidebarElement, 20);
    window.addEventListener('scroll', eventHandler, { passive: true });
    window.addEventListener('resize', eventHandler, { passive: true });
  }
}

/**
 * Throttle a function's invocation so that it is run at most
 * once every waitMs milliseconds.
 *
 * The function is guaranteed to run after the last call.
 */
function debounce(fn: () => void, waitMs: number): () => void {
  let lastInvoked = 0;
  let timer: number | null = null;

  const wrappedFn = function () {
    const now = new Date().getTime();
    const elapsed = now - lastInvoked;

    if (elapsed >= waitMs || elapsed < 0 /* handle case where clock goes backwards */) {
      lastInvoked = now;
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      window.clearTimeout(timer!);
      timer = null;
      fn();
    } else if (timer === null) {
      timer = window.setTimeout(wrappedFn, waitMs - elapsed);
    }
  };

  return wrappedFn;
}
